import { render, staticRenderFns } from "./SelfPersonBillInfo.vue?vue&type=template&id=b09c0e12&scoped=true&"
import script from "./SelfPersonBillInfo.vue?vue&type=script&lang=js&"
export * from "./SelfPersonBillInfo.vue?vue&type=script&lang=js&"
import style0 from "./SelfPersonBillInfo.vue?vue&type=style&index=0&id=b09c0e12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09c0e12",
  null
  
)

export default component.exports